import type { ReactNode } from 'react'

/** ホームを大きく区切るグループ見出し（要対応 / 診察スケジュール など）。ブランド色の縦バーで見出しらしさを出す */
export function GroupHeading({ title }: { title: string }) {
  return (
    <h2 className="flex items-center gap-2.5 text-xl font-bold text-[#1a1f36]">
      <span className="w-1.5 self-stretch rounded-sm bg-[#2196F3]" aria-hidden="true" />
      {title}
    </h2>
  )
}

/** グループ見出しと配下コンテンツをまとめるカード。tone="attention"は要対応用の薄ピンク背景 */
export function GroupCard({ header, children, tone }: { header: ReactNode; children: ReactNode; tone?: 'attention' }) {
  const toneClass = tone === 'attention' ? 'bg-pink-50 border-pink-200' : 'bg-white border-gray-200'
  return (
    <section className={`${toneClass} border rounded-xl shadow-sm p-4 sm:p-6 mb-8`}>
      <div className="mb-4">{header}</div>
      {children}
    </section>
  )
}
